import React from 'react';
import { LANGUAGES } from '../../i18n/languages';
import { ta } from '../../i18n/adminT';

// Menu a tendina per la lingua del pannello amministratore. È una scelta
// personale di ogni utente (salvata sul suo account), indipendente dalle
// lingue offerte ai visitatori.
export default function AdminLanguageSelect({ value, onChange }) {
  return (
    <label style={{ display: 'block', padding: '0 14px 10px' }}>
      <span style={{ display: 'block', color: 'rgba(246,245,241,0.5)', fontSize: '0.7rem', marginBottom: 4 }}>
        {ta('Lingua del pannello')}
      </span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={ta('Lingua del pannello')}
        style={{
          width: '100%',
          padding: '6px 8px',
          borderRadius: 6,
          border: '1px solid rgba(246,245,241,0.25)',
          background: 'rgba(246,245,241,0.08)',
          color: '#f6f5f1',
          fontSize: '0.85rem',
        }}
      >
        {LANGUAGES.map(({ key, label, flag }) => (
          <option key={key} value={key} style={{ color: '#1a1a1a', background: '#fff' }}>
            {flag} {label}
          </option>
        ))}
      </select>
    </label>
  );
}
